
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export default class TechnicalSkill extends Vue {
  @Prop({ type: Object, required: true }) isTop!: { isTisikiTop: boolean; isGinouTop: boolean; isSikouTop: boolean; isTaizinTop: boolean; isManagementTop: boolean };
}
